import React from 'react'
import classes from './Scrollbars.module.scss'

const Scrollbars = ({
  children,

  big,
  component = 'div',
  className,

  ...props
}, ref) => {
  const Component = component

  let compClassName = classes.scrollbars
  if (big) compClassName += ' ' + classes.big
  if (className) compClassName += ' ' + className

  return (
    <Component
      {...props}
      ref={ref}
      className={compClassName}
    >
      {children}
    </Component>
  )
}

export default React.forwardRef(Scrollbars)
